import { Component, Inject, Input, OnInit, OnDestroy } from '@angular/core';

import { AlertState, AlertType, ApplicationFacade, NotificationFacade, AlertDisplayMode } from '@ridango/components';

import { timer } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import Env from '@ridango/core/env';
import { BaseComponent } from '@ridango/core';

/**
 * Modal/Popup Alert Component (V2)
 * Displays alerts as modal popups for mobile applications.
 */
@Component({
    selector: 'rwidget-ui-modal-alert',
    templateUrl: './ui-modal-alert.component.html',
    styleUrls: ['./ui-modal-alert.component.scss']
})
export class UiModalAlertComponent extends BaseComponent implements OnInit, OnDestroy {
    AlertType = AlertType;
    @Input() duration = null; // WCAG suggests no timers for important messages
    /** Optional target id for this modal instance. When set, only alerts targeted to this id will be shown here. */
    @Input() target: string | undefined | null;

    assetsPath$ = this.applicationFacade.assetsPath$;

    notifications: AlertState[] = [];

    constructor(
        private applicationFacade: ApplicationFacade,
        private notification: NotificationFacade,
        @Inject('ENV') public env: Env
    ) {
        super();
    }

    ngOnInit() {
        // Subscribe to modal/popup alerts from the store. If this instance has a target configured,
        // subscribe to only the alerts for that target and mode. Otherwise use the global modal stream.
        const alerts$ = this.target
            ? this.notification.getAlertsByTargetAndMode(this.target, AlertDisplayMode.Modal)
            : this.notification.onAlertV2();

        alerts$.pipe(takeUntil(this.componentDestroyed$)).subscribe((alerts) => {
            // Update notifications with the latest alerts from store
            this.notifications = alerts;

            // Auto-dismiss individual alerts based on their duration
            for (const alert of alerts) {
                if (this.duration !== null || alert.duration) {
                    const timeToClose = this.duration !== null ? this.duration : alert.duration;
                    timer(timeToClose)
                        .pipe(takeUntil(this.componentDestroyed$))
                        .subscribe(() => {
                            this.closeNotification(alert);
                        });
                }
            }
        });
    }

    ngOnDestroy() {
        super.ngOnDestroy();
    }

    closeNotification(notification: AlertState) {
        this.notification.remove(notification);
    }
}
